import { QueryClient } from "@tanstack/react-query"

/**
 * Global TanStack Query client.
 * Defaults: cache-friendly, retries are conservative, no aggressive refetch.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // 30s
      gcTime: 5 * 60_000, // 5min
      retry: (failureCount, error) => {
        // 4xx — kullanıcı hatası, retry yok
        if (error instanceof Error && "status" in error && typeof error.status === "number") {
          if (error.status >= 400 && error.status < 500) {
            return false
          }
        }
        return failureCount < 2
      },
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 0,
    },
  },
})
